export const APP_ID = '3001';
export const APP_NAME = 'MinimaxChat';

export const APP_VERSION_WEB = '22201';
export const APP_VERSION_H5 = '22201';
export const APP_VERSION_MINI = '22201';

export const GOOGLE_ANALYTICS_ID = 'G-VRK417KFJZ';

export enum BIZ_LINE {
  VIDEO = 0,
  AUDIO = 1,
  TEXT = 2,
}
